module.exports = __webpack_public_path__ + "static/UNITY-Tower-lower-floor-4-tenants_v2-en-9b2d659f8cba89c5ca1fda31353c25ca.pdf";